import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { withRouter } from "../../../app-services/lib/router-compat";
import { RowWrapper, CheckoutFlow } from "./CheckoutFLow";
import "./CheckoutSteps.css";

export function CheckoutSteps(props) {
  const self = useRef({}).current;
  const addToCart = props.addToCart || (() => "");
  const [steps, setSteps] = useState(CheckoutFlow);
  const [currentStep, setCurrentStep] = useState(props.currentStep || 0);
  const prevPropsRef = useRef(props);

  self.props = props;

  useLayoutEffect(() => {
    initialConstruct.bind(self)("CheckoutSteps", props);
    self.addToCart = addToCart;
  }, []);

  self.setState = (update) => {
    if (typeof update === "function") {
      const next = update({ steps, currentStep }, props);
      if (next.steps !== undefined) setSteps(next.steps);
      if (next.currentStep !== undefined) setCurrentStep(next.currentStep);
    } else {
      if (update.steps !== undefined) setSteps(update.steps);
      if (update.currentStep !== undefined) setCurrentStep(update.currentStep);
    }
  };

  useEffect(() => {
    self.watch(
      {
        steps(val) {
          setSteps(val || []);
        },
      },
      props,
      prevPropsRef.current
    );
    prevPropsRef.current = props;
  });

  const nextStep = (dir) => {
    switch (dir + "") {
      case "1":
        if (currentStep + dir <= steps.length - 1) {
          setCurrentStep(currentStep + dir);
        }
        break;
      case "-1":
        if (currentStep + dir >= 0) {
          setCurrentStep(currentStep + dir);
        }
        break;
    }
  };

  let { onAnswer, keys = [], onSave, bookname } = props;
  return (
    <div className="CheckoutSteps">
      <div className="step-contents">
        {steps
          .filter((v) => keys.includes(v.name))
          .map((obj, i) => (
            <div
              className={Object.className({
                step: true,
                active: i == currentStep,
              })}
              key={i}
            >
              {
                <obj.Component
                  onAnswer={onAnswer}
                  onSave={onSave}
                  bookname={bookname}
                />
              }
            </div>
          ))}
      </div>
      <RowWrapper>
        <div className="step-bars col-lg-12">
          <div className="row no-gutters customize-container">
            {steps
              .filter((v) => keys.includes(v.name))
              .map((obj, i) => (
                <div
                  className={Object.className({
                    stepbar: true,
                    col: true,
                    "col-lg-3": true,
                    "col-xl-2": true,
                    visited: i <= currentStep,
                    active: i == currentStep,
                  })}
                  key={i}
                >
                  <div
                    className="label"

                    onClick={() =>
                      (
                        obj.onClick || (() => setCurrentStep(i))
                      )({ me: self, obj, currentStep, i })
                    }
                  >
                    <i className="fa fa-caret-right " style={{
                      marginRight: '10px'
                    }} ></i>
                    {obj.subheading}
                  </div>
                  <div className="subheading" >{obj.label}</div>
                </div>
              ))}
          </div>
        </div>
      </RowWrapper>
      <RowWrapper>
        <div className="col-lg-10 pt-2 continuebtns">
          {currentStep ==
            steps.filter((v) => keys.includes(v.name)).length - 1 ||
            steps.filter((v) => keys.includes(v.name)).length == 0 ? (
            <>
              {/* {(
                                  currentStep > 0 &&
                                  <button
                                      className="continuebtn"
                                      type="button"
                                      onClick={() => nextStep(-1)}
                                  >
                                      PREV
                                  </button>
                              )} */}
              <button
                className="continuebtn"
                type="button"
                id="add2cart"
                onClick={() => addToCart()}
              >
                ADD TO CART
              </button>
            </>
          ) : (
            <>
              {/* <button
                                      className="continuebtn"
                                      type="button"
                                      onClick={() => nextStep(-1)}
                                  >
                                      PREV
                                  </button> */}
              <button
                className="continuebtn"
                type="button"
                onClick={() => nextStep(1)}
              >
                NEXT
              </button>
            </>
          )}
        </div>
      </RowWrapper>
    </div>
  );
}

export default connect(withRouter(CheckoutSteps));
